import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";

import { cn } from "@/lib/utils/cn";

const badgeVariants = cva(
    "inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-[0.8125rem] font-medium whitespace-nowrap",
    {
        variants: {
            variant: {
                default: "bg-secondary text-secondary-foreground",
                success: "bg-success/15 text-success",
                destructive: "bg-destructive/15 text-destructive",
                warning: "bg-warning/15 text-warning",
                outline: "border text-foreground",
            },
        },
        defaultVariants: { variant: "default" },
    },
);

export function Badge({ className, variant, ...props }: ComponentProps<"span"> & VariantProps<typeof badgeVariants>) {
    return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
